import { Link } from 'react-router-dom';
import { navbarLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <span className="font-heading text-2xl text-white">爱漫画网</span>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              提供下拉式漫画阅读、翻页漫画、无弹窗漫画等多种阅读模式，支持漫画全屏观看。沉浸式追漫体验，让免费看漫画全集更流畅。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">
              <a href="/category/all" className="hover:text-primary-400 transition-colors">漫画分类</a>
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/hot-blooded" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">热血漫画</Link>
              <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">恋爱漫画</Link>
              <Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">奇幻漫画</Link>
              <Link to="/category/comedy" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">搞笑漫画</Link>
              <Link to="/category/sci-fi" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">科幻漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">
              <a href="/article/latest" className="hover:text-primary-400 transition-colors">漫资讯</a>
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/article/doupo-cangqiong" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">斗破苍穹深度解读</Link>
              <Link to="/article/yirenzhixia" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">一人之下世界观</Link>
              <Link to="/article/manhua-trend-2026" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">2026国漫趋势</Link>
              <Link to="/article/reading-mode-guide" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">阅读模式全攻略</Link>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">
              <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">品牌介绍</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
              <Link to="/article/free-comic-guide" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors whitespace-nowrap cursor-pointer">使用指南</Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; 2026 爱漫画网 版权所有 | 致力于提供最优质的在线漫画阅读体验
          </p>
          <div className="flex items-center gap-5">
            <a href="/about" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors">隐私政策</a>
            <a href="/about" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors">服务条款</a>
            <a href="/about" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}